import { Trans } from '@lingui/react/macro';
import { FilterButton, Menu } from '@pocketlaw/tetris';
import { SearchTextFieldAllowedPropertiesForTextFieldSearch, } from 'shared/domains/apollo/generated/types';
import { allowedSearchFields } from '../SearchModifierMenu/searchFieldValues';
export function SearchFieldModifier(props) {
    const { modifiers, setModifiers } = props;
    const values = allowedSearchFields();
    const isSelected = (value) => { var _a; return (_a = modifiers.searchFields) === null || _a === void 0 ? void 0 : _a.some((field) => field.field === value); };
    const [defaultValue] = values;
    const selectedField = values.find((field) => isSelected(field.id));
    const handleSelect = (value) => {
        if (value === SearchTextFieldAllowedPropertiesForTextFieldSearch.AllApplicable) {
            setModifiers({ searchFields: [] });
        }
        else {
            setModifiers({ searchFields: [{ field: value }] });
        }
    };
    return (<Menu.Root target={<FilterButton>
          <b>
            <Trans comment="Universal search - search field: Title">Search field:</Trans>
          </b>
          {(selectedField === null || selectedField === void 0 ? void 0 : selectedField.name) || defaultValue.name}
        </FilterButton>}>
      {values.map((field) => (<Menu.ItemRadio key={field.id} checked={(selectedField === null || selectedField === void 0 ? void 0 : selectedField.id) === field.id} onChange={() => handleSelect(field.id)}>
          <Menu.ItemText truncate={false} primary={field.name} secondary={field.description}/>
        </Menu.ItemRadio>))}
    </Menu.Root>);
}
